var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.isNamedFilter
        ? _c("app-custom-filter-selector", {
            attrs: { model: _vm.namedFilterModel, value: _vm.filter },
          })
        : _vm.field
        ? _c("app-human-filter-edit-value", {
            attrs: {
              filter: _vm.filter,
              "field-type": _vm.fieldType,
              labels: _vm.filter.Labels,
              model: _vm.model,
              "disable-use-value-of-other-field": "",
            },
          })
        : _vm._e(),
      _vm.filter.IsOptional
        ? _c(
            "w-col",
            {
              staticClass: "mb optional-checkbox-wrapper",
              attrs: { xs: "12" },
            },
            [
              _c("w-checkbox", {
                attrs: {
                  value: !_vm.filter.OptionalFilterIsDisabled,
                  label: _vm.$ct("use-this-asked-filter"),
                },
                on: {
                  input: function ($event) {
                    _vm.filter.OptionalFilterIsDisabled = !$event
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }